var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "max-w-screen-lg"
  }, [_c('div', {
    staticClass: "flex flex-col gap-y-8"
  }, [_c('div', {
    staticClass: "flex relative bg-blue-600 py-6 px-10 gap-3 text-white rounded-lg"
  }, [_c('div', [_c('div', {
    staticClass: "flex flex-row items-center gap-2"
  }, [_c('Icon', {
    staticClass: "hidden md:block -ml-4 mr-2 opacity-50 transform -rotate-12 self-center text-white",
    attrs: {
      "name": "star",
      "size": "12"
    }
  }), _vm._m(0)], 1)])]), _c('div', {
    staticClass: "text-gray-800 flex flex-col gap-y-4"
  }, [_c('p', [_vm._v("Here is your referral link:")]), _c('div', {
    staticClass: "max-w-screen-sm"
  }, [_vm.me && _vm.me.id ? _c('YInput', {
    staticClass: "text-black",
    attrs: {
      "value": _vm.referralCode,
      "id": "referralCode",
      "label": "Your Referral Code",
      "type": "text",
      "readonly": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "mt-2 ml-2 text-xs text-blue-600 hover:text-blue-800 cursor-pointer",
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v(" Copy Link ")])], 1)])]), _c('div', {
    staticClass: "mt-8"
  }, [_c('Expandable', {
    attrs: {
      "title": "All In Referral Program Overview",
      "initial-state": false,
      "clickable-class": "flex w-full justify-between rounded-lg bg-gray-100 px-4 py-8 text-left hover:bg-gray-200 focus:outline-none"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', {
          staticClass: "flex flex-col gap-2 text-xs"
        }, [_c('p', {
          staticClass: "text-lg font-bold"
        }, [_vm._v("All In Referral Program Overview")])])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pb-2 mt-4 bg-gray-50 rounded-md"
  }, [_c('div', {
    staticClass: "eligibility p-4 lg:p-8"
  }, [_c('div', {
    staticClass: "mb-8"
  }, [_c('h2', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v("Eligibility Criteria")]), _c('ul', {
    staticClass: "list-decimal ml-8"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("The referred sub-affiliate must:")]), _c('ul', {
    staticClass: "list-disc ml-4 mb-4"
  }, [_c('li', [_vm._v(" Be a new member to the network (no existing accounts). ")]), _c('li', [_vm._v(" Actively promote campaigns and generate valid conversions. ")])])]), _c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" The conversions must be genuine, non-fraudulent, and meet the specific campaign terms. ")])])])]), _c('div', {
    staticClass: "mb-8"
  }, [_c('h2', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v("Payment Terms")]), _c('ol', {
    staticClass: "list-decimal ml-8"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" The 5% revenue share payments will be calculated and credited monthly, based on the referred sub-affiliate's performance during the qualifying 6-month period. ")])]), _c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" Payments will be credited to the referring affiliate's account within 15 days from the end of the month. ")])])])]), _c('div', {
    staticClass: "mb-8"
  }, [_c('h2', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v("Important Notes")]), _c('ol', {
    staticClass: "list-decimal ml-8"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "font-semibold mb-2"
  }, [_vm._v("Fraud Prevention:")]), _c('ul', {
    staticClass: "list-disc ml-4 mb-4"
  }, [_c('li', [_vm._v(" All referrals are subject to review. Fraudulent activity, including self-referrals or artificial traffic, will result in disqualification from the program. ")])])]), _c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "font-semibold mb-2"
  }, [_vm._v("Multiple Referrals:")]), _c('ul', {
    staticClass: "list-disc ml-4 mb-4"
  }, [_c('li', [_vm._v(" There is no limit to the number of sub-affiliates you can refer. ")])])]), _c('li', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "font-semibold mb-2"
  }, [_vm._v("Program Modifications:")]), _c('ul', {
    staticClass: "list-disc ml-4 mb-4"
  }, [_c('li', [_vm._v(" YTZ reserves the right to modify or terminate this program at any time with prior notice to participants. ")])])])])])])])])], 1), _c('div', {
    staticClass: "table-container mt-12"
  }, [_c('h2', {
    staticClass: "text-lg font-semibold mb-2"
  }, [_vm._v("Sub-Affiliate Commissions")]), _c('YTable', {
    staticClass: "table table-sm w-full",
    attrs: {
      "data": _vm.subAffiliateCommissions,
      "loading": _vm.reportLoading,
      "empty-text": !_vm.reportLoading ? 'No sub-affiliate commission data available.' : 'Loading...'
    },
    scopedSlots: _vm._u([{
      key: "header-row",
      fn: function () {
        return [_c('th', {
          staticClass: "px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        }, [_vm._v(" Referred Affiliate ID ")]), _c('th', {
          staticClass: "px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        }, [_vm._v(" Month ")]), _c('th', {
          staticClass: "px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        }, [_vm._v(" Commission ")])];
      },
      proxy: true
    }, {
      key: "row",
      fn: function (_ref) {
        var rowData = _ref.rowData;
        return [_c('td', {
          staticClass: "px-6 py-4 whitespace-no-wrap border-b border-gray-200"
        }, [_vm._v(" " + _vm._s(rowData.id) + " ")]), _c('td', {
          staticClass: "px-6 py-4 whitespace-no-wrap border-b border-gray-200"
        }, [_vm._v(" " + _vm._s(rowData.month) + " ")]), _c('td', {
          staticClass: "px-6 py-4 whitespace-no-wrap border-b border-gray-200"
        }, [_vm._v(" " + _vm._s(_vm.$formatMoney(rowData.commission)) + " ")])];
      }
    }])
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "text-lg leading-snug font-semibold"
  }, [_vm._v(" Refer Sub-Affiliates to receive "), _c('span', {
    staticClass: "font-extrabold"
  }, [_vm._v("5%")]), _vm._v(" of their commissions on the first 6 months. ")]);

}]

export { render, staticRenderFns }